import React from "react";
import { Container, Row, Col, Card } from "reactstrap";
import Slider from "react-slick";
import { Link } from "react-router-dom";

function LiveCard({ news, overlay, setOverlay }) {
  const size = "28rem";
  return (
    <Link to={`insights/${news.link}/`}>
      <Card
        style={{
          maxWidth: "none",
          minHeight: size,
          maxHeight: size,
        }}
        onMouseEnter={() => setOverlay([news, true])}
        onMouseLeave={() => setOverlay([news, false])}
      >
        <Container fluid className="p-0">
          <img
            alt="..."
            className="img-rounded"
            width="100%"
            src={require(`assets/images/news/${news.image}`)}
          />
        </Container>
        <Container
          fluid
          style={{
            borderRadius: "0 0 10px 10px",
            background: "#fff",
            zIndex: 10,
            minHeight: "100px",
            position: "absolute",
            bottom: 0,
          }}
        >
          <Row>
            <>
              <Col xs={12} className="mt-2 ">
                <h4 className="d-inline text-500">{news.description}</h4>
              </Col>
            </>
          </Row>
        </Container>
      </Card>
    </Link>
  );
}

function Live({ live }) {
  let pageHeader = React.createRef();
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth > 1024 ? true : false;
  const [overlay, setOverlay] = React.useState([live[0], false]);
  const settings = {
    dots: true,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 8000,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
  };

  return (
    <div
      style={{
        backgroundColor: "transparent",

        zIndex: 5,
      }}
      className="section section-with-space"
      data-parallax={true}
      ref={pageHeader}
    >
      <Container>
        <Row className="justify-content-center">
          <Col lg={8}>
            <img src={require("assets/images/insight.png")} alt="insight" width="100%" />
          </Col>
        </Row>
        <Row className="justify-content-center">
          {size ? (
            live.map((l, i) => (
              <Col lg={4} key={i}>
                <LiveCard news={l} overlay={overlay} setOverlay={setOverlay} />
              </Col>
            ))
          ) : (
            <Col sm={8} xs={12} className={"ml-auto mr-auto"}>
              <Slider {...settings}>
                {live.map((l) => (
                  <LiveCard news={l} key={l.id} overlay={overlay} setOverlay={setOverlay} />
                ))}
              </Slider>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
}

export default Live;
